import * as Yup from "yup";

export const AddChangePlayerInitialState = {
  team: "",
  time: "",
  playerOut: "",
  playerIn: "",
};

export const AddChangePlayerValidationSchema = Yup.object({
  team: Yup.string().required("Este campo es requerido"),
  time: Yup.string().required("Este campo es requerido"),
  playerOut: Yup.string().required("Este campo es requerido"),
  playerIn: Yup.string().required("Este campo es requerido"),
});
